(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  if (root && typeof root === 'object') {
    root.ToeeSizeCombo = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function handleize(str) {
    return String(str == null ? '' : str)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function tagHandle(prefix, value) {
    var val = handleize(value);
    if (!val) return '';
    var pre = handleize(prefix);
    return pre ? pre + '_' + val : val;
  }

  function prefixOfTag(tag) {
    var raw = String(tag == null ? '' : tag);
    var i = raw.indexOf('_');
    return i === -1 ? raw : raw.slice(0, i);
  }

  function suffixOfTag(tag) {
    var raw = String(tag == null ? '' : tag);
    var i = raw.indexOf('_');
    return i === -1 ? '' : raw.slice(i + 1);
  }

  function selectedList(handles) {
    return (handles || []).filter(function (h) { return !!h; });
  }

  function concatHandles(lockHandles, selectedHandles) {
    return selectedList(lockHandles).concat(selectedList(selectedHandles));
  }

  function cleanCollectionUrl(url) {
    return String(url || '').replace(/\/$/, '');
  }

  function comboUrl(collectionUrl, selectedHandles) {
    var base = cleanCollectionUrl(collectionUrl);
    var tags = selectedList(selectedHandles);
    return base + (tags.length ? '/' + tags.join('+') : '') + '?view=size-options';
  }

  function searchUrl(collectionUrl, selectedHandles) {
    var base = cleanCollectionUrl(collectionUrl);
    var tags = selectedList(selectedHandles);
    return base + (tags.length ? '/' + tags.join('+') : '');
  }

  // Searchanise RapidBoost hashes = MD5 of "<tagPrefix>_". Values are bucket
  // suffixes (16, 5*114.3, 6.5), not Shopify tag handles (diameter_16).
  var SNIZE_PTAG_HASH = {
    Diameter: '99bcd488e555c001c1be0e5fba3d7778',
    'H/PCD': 'ac3a4e1adb32bd7c68947d12ff4b54a8',
    WidthR: '1ce0d68c73d898ee9b9650f420335c21',
    Width: '714c2b56e55172c5b7e793c8ddc0ad5f',
    Aspect: 'c31fce9ad7dc9ec318db582d54517561',
    CB: 'c8c052194a4c6cb304c124eb6e014dc4'
  };

  function snizeFilterValue(prefix, label) {
    var v = String(label == null ? '' : label).trim();
    v = v.replace(/["″”]+$/g, '');
    if (prefix === 'H/PCD' || handleize(prefix) === 'h-pcd') {
      v = v.replace(/[×xX]/g, '*');
    }
    return v;
  }

  function snizeSearchUrl(collectionUrl, filters) {
    var base = cleanCollectionUrl(collectionUrl);
    var parts = [];
    (filters || []).forEach(function (f) {
      if (!f || !f.prefix) return;
      var value = snizeFilterValue(f.prefix, f.value);
      if (!value) return;
      var hash = SNIZE_PTAG_HASH[f.prefix];
      if (!hash) return;
      parts.push('rb_filter_ptag_' + hash + '=' + encodeURIComponent(value).replace(/\*/g, '%2A'));
    });
    return parts.length ? base + '?' + parts.join('&') : base;
  }

  function pruneSelected(options, currentHandle) {
    if (!currentHandle) return '';
    var list = options || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].handle === currentHandle) return currentHandle;
    }
    return '';
  }

  function rebuildAfterChange(selected, changedIndex) {
    var next = (selected || []).slice();
    for (var i = changedIndex + 1; i < next.length; i++) next[i] = '';
    return next;
  }

  function parseSizeOptions(json) {
    var src = json || {};
    return {
      productCount: src.productCount || 0,
      page: src.page || 1,
      pages: src.pages || 1,
      path: src.path || '',
      groups: src.groups || {}
    };
  }

  function pickSearchCollection(primaryUrl, extraUrl, primaryCount, extraCount) {
    var primary = cleanCollectionUrl(primaryUrl);
    var extra = extraUrl ? cleanCollectionUrl(extraUrl) : '';
    if (!extra || extra === primary) return primary;
    var primaryHits = Number(primaryCount) || 0;
    var extraHits = Number(extraCount) || 0;
    if (extraHits > 0 && primaryHits === 0) return extra;
    return primary;
  }

  return {
    handleize: handleize,
    tagHandle: tagHandle,
    prefixOfTag: prefixOfTag,
    suffixOfTag: suffixOfTag,
    concatHandles: concatHandles,
    comboUrl: comboUrl,
    searchUrl: searchUrl,
    snizeFilterValue: snizeFilterValue,
    snizeSearchUrl: snizeSearchUrl,
    pickSearchCollection: pickSearchCollection,
    pruneSelected: pruneSelected,
    rebuildAfterChange: rebuildAfterChange,
    parseSizeOptions: parseSizeOptions
  };
});
